export const countryCallingCodes = [
  {
    country: 'UZ',
    callingCode: '+998',
  },
  {
    country: 'KG',
    callingCode: '+996',
  },
  {
    country: 'GE',
    callingCode: '+995',
  },
  {
    country: 'AZ',
    callingCode: '+994',
  },
  {
    country: 'TM',
    callingCode: '+993',
  },
  {
    country: 'TJ',
    callingCode: '+992',
  },
  {
    country: 'NP',
    callingCode: '+977',
  },
  {
    country: 'MN',
    callingCode: '+976',
  },
  {
    country: 'BT',
    callingCode: '+975',
  },
  {
    country: 'QA',
    callingCode: '+974',
  },
  {
    country: 'BH',
    callingCode: '+973',
  },
  {
    country: 'IL',
    callingCode: '+972',
  },
  {
    country: 'AE',
    callingCode: '+971',
  },
  {
    country: 'PS',
    callingCode: '+970',
  },
  {
    country: 'OM',
    callingCode: '+968',
  },
  {
    country: 'YE',
    callingCode: '+967',
  },
  {
    country: 'SA',
    callingCode: '+966',
  },
  {
    country: 'KW',
    callingCode: '+965',
  },
  {
    country: 'IQ',
    callingCode: '+964',
  },
  {
    country: 'SY',
    callingCode: '+963',
  },
  {
    country: 'JO',
    callingCode: '+962',
  },
  {
    country: 'LB',
    callingCode: '+961',
  },
  {
    country: 'MV',
    callingCode: '+960',
  },
  {
    country: 'TW',
    callingCode: '+886',
  },
  {
    country: 'BD',
    callingCode: '+880',
  },
  {
    country: 'LA',
    callingCode: '+856',
  },
  {
    country: 'KH',
    callingCode: '+855',
  },
  {
    country: 'MO',
    callingCode: '+853',
  },
  {
    country: 'HK',
    callingCode: '+852',
  },
  {
    country: 'KP',
    callingCode: '+850',
  },
  {
    country: 'MH',
    callingCode: '+692',
  },
  {
    country: 'FM',
    callingCode: '+691',
  },
  {
    country: 'TK',
    callingCode: '+690',
  },
  {
    country: 'PF',
    callingCode: '+689',
  },
  {
    country: 'TV',
    callingCode: '+688',
  },
  {
    country: 'NC',
    callingCode: '+687',
  },
  {
    country: 'KI',
    callingCode: '+686',
  },
  {
    country: 'WS',
    callingCode: '+685',
  },
  {
    country: 'NU',
    callingCode: '+683',
  },
  {
    country: 'CK',
    callingCode: '+682',
  },
  {
    country: 'WF',
    callingCode: '+681',
  },
  {
    country: 'PW',
    callingCode: '+680',
  },
  {
    country: 'FJ',
    callingCode: '+679',
  },
  {
    country: 'VU',
    callingCode: '+678',
  },
  {
    country: 'SB',
    callingCode: '+677',
  },
  {
    country: 'TO',
    callingCode: '+676',
  },
  {
    country: 'PG',
    callingCode: '+675',
  },
  {
    country: 'NR',
    callingCode: '+674',
  },
  {
    country: 'BN',
    callingCode: '+673',
  },
  {
    country: 'NF',
    callingCode: '+672',
  },
  {
    country: 'TL',
    callingCode: '+670',
  },
  {
    country: 'BQ',
    callingCode: '+599',
  },
  {
    country: 'CW',
    callingCode: '+599',
  },
  {
    country: 'UY',
    callingCode: '+598',
  },
  {
    country: 'SR',
    callingCode: '+597',
  },
  {
    country: 'MQ',
    callingCode: '+596',
  },
  {
    country: 'PY',
    callingCode: '+595',
  },
  {
    country: 'GF',
    callingCode: '+594',
  },
  {
    country: 'EC',
    callingCode: '+593',
  },
  {
    country: 'GY',
    callingCode: '+592',
  },
  {
    country: 'BO',
    callingCode: '+591',
  },
  {
    country: 'BL',
    callingCode: '+590',
  },
  {
    country: 'GP',
    callingCode: '+590',
  },
  {
    country: 'MF',
    callingCode: '+590',
  },
  {
    country: 'HT',
    callingCode: '+509',
  },
  {
    country: 'PM',
    callingCode: '+508',
  },
  {
    country: 'PA',
    callingCode: '+507',
  },
  {
    country: 'CR',
    callingCode: '+506',
  },
  {
    country: 'NI',
    callingCode: '+505',
  },
  {
    country: 'HN',
    callingCode: '+504',
  },
  {
    country: 'SV',
    callingCode: '+503',
  },
  {
    country: 'GT',
    callingCode: '+502',
  },
  {
    country: 'BZ',
    callingCode: '+501',
  },
  {
    country: 'FK',
    callingCode: '+500',
  },
  {
    country: 'LI',
    callingCode: '+423',
  },
  {
    country: 'SK',
    callingCode: '+421',
  },
  {
    country: 'CZ',
    callingCode: '+420',
  },
  {
    country: 'MK',
    callingCode: '+389',
  },
  {
    country: 'BA',
    callingCode: '+387',
  },
  {
    country: 'SI',
    callingCode: '+386',
  },
  {
    country: 'HR',
    callingCode: '+385',
  },
  {
    country: 'XK',
    callingCode: '+383',
  },
  {
    country: 'ME',
    callingCode: '+382',
  },
  {
    country: 'RS',
    callingCode: '+381',
  },
  {
    country: 'UA',
    callingCode: '+380',
  },
  {
    country: 'SM',
    callingCode: '+378',
  },
  {
    country: 'MC',
    callingCode: '+377',
  },
  {
    country: 'AD',
    callingCode: '+376',
  },
  {
    country: 'BY',
    callingCode: '+375',
  },
  {
    country: 'AM',
    callingCode: '+374',
  },
  {
    country: 'MD',
    callingCode: '+373',
  },
  {
    country: 'EE',
    callingCode: '+372',
  },
  {
    country: 'LV',
    callingCode: '+371',
  },
  {
    country: 'LT',
    callingCode: '+370',
  },
  {
    country: 'BG',
    callingCode: '+359',
  },
  {
    country: 'AX',
    callingCode: '+358',
  },
  {
    country: 'FI',
    callingCode: '+358',
  },
  {
    country: 'CY',
    callingCode: '+357',
  },
  {
    country: 'MT',
    callingCode: '+356',
  },
  {
    country: 'AL',
    callingCode: '+355',
  },
  {
    country: 'IS',
    callingCode: '+354',
  },
  {
    country: 'IE',
    callingCode: '+353',
  },
  {
    country: 'LU',
    callingCode: '+352',
  },
  {
    country: 'PT',
    callingCode: '+351',
  },
  {
    country: 'GI',
    callingCode: '+350',
  },
  {
    country: 'GL',
    callingCode: '+299',
  },
  {
    country: 'FO',
    callingCode: '+298',
  },
  {
    country: 'AW',
    callingCode: '+297',
  },
  {
    country: 'ER',
    callingCode: '+291',
  },
  {
    country: 'SH',
    callingCode: '+290',
  },
  {
    country: 'TA',
    callingCode: '+290',
  },
  {
    country: 'KM',
    callingCode: '+269',
  },
  {
    country: 'SZ',
    callingCode: '+268',
  },
  {
    country: 'BW',
    callingCode: '+267',
  },
  {
    country: 'LS',
    callingCode: '+266',
  },
  {
    country: 'MW',
    callingCode: '+265',
  },
  {
    country: 'NA',
    callingCode: '+264',
  },
  {
    country: 'ZW',
    callingCode: '+263',
  },
  {
    country: 'RE',
    callingCode: '+262',
  },
  {
    country: 'YT',
    callingCode: '+262',
  },
  {
    country: 'MG',
    callingCode: '+261',
  },
  {
    country: 'ZM',
    callingCode: '+260',
  },
  {
    country: 'MZ',
    callingCode: '+258',
  },
  {
    country: 'BI',
    callingCode: '+257',
  },
  {
    country: 'UG',
    callingCode: '+256',
  },
  {
    country: 'TZ',
    callingCode: '+255',
  },
  {
    country: 'KE',
    callingCode: '+254',
  },
  {
    country: 'DJ',
    callingCode: '+253',
  },
  {
    country: 'SO',
    callingCode: '+252',
  },
  {
    country: 'ET',
    callingCode: '+251',
  },
  {
    country: 'RW',
    callingCode: '+250',
  },
  {
    country: 'SD',
    callingCode: '+249',
  },
  {
    country: 'SC',
    callingCode: '+248',
  },
  {
    country: 'AC',
    callingCode: '+247',
  },
  {
    country: 'IO',
    callingCode: '+246',
  },
  {
    country: 'GW',
    callingCode: '+245',
  },
  {
    country: 'AO',
    callingCode: '+244',
  },
  {
    country: 'CD',
    callingCode: '+243',
  },
  {
    country: 'CG',
    callingCode: '+242',
  },
  {
    country: 'GA',
    callingCode: '+241',
  },
  {
    country: 'GQ',
    callingCode: '+240',
  },
  {
    country: 'ST',
    callingCode: '+239',
  },
  {
    country: 'CV',
    callingCode: '+238',
  },
  {
    country: 'CM',
    callingCode: '+237',
  },
  {
    country: 'CF',
    callingCode: '+236',
  },
  {
    country: 'TD',
    callingCode: '+235',
  },
  {
    country: 'NG',
    callingCode: '+234',
  },
  {
    country: 'GH',
    callingCode: '+233',
  },
  {
    country: 'SL',
    callingCode: '+232',
  },
  {
    country: 'LR',
    callingCode: '+231',
  },
  {
    country: 'MU',
    callingCode: '+230',
  },
  {
    country: 'BJ',
    callingCode: '+229',
  },
  {
    country: 'TG',
    callingCode: '+228',
  },
  {
    country: 'NE',
    callingCode: '+227',
  },
  {
    country: 'BF',
    callingCode: '+226',
  },
  {
    country: 'CI',
    callingCode: '+225',
  },
  {
    country: 'GN',
    callingCode: '+224',
  },
  {
    country: 'ML',
    callingCode: '+223',
  },
  {
    country: 'MR',
    callingCode: '+222',
  },
  {
    country: 'SN',
    callingCode: '+221',
  },
  {
    country: 'GM',
    callingCode: '+220',
  },
  {
    country: 'LY',
    callingCode: '+218',
  },
  {
    country: 'TN',
    callingCode: '+216',
  },
  {
    country: 'DZ',
    callingCode: '+213',
  },
  {
    country: 'EH',
    callingCode: '+212',
  },
  {
    country: 'MA',
    callingCode: '+212',
  },
  {
    country: 'SS',
    callingCode: '+211',
  },
  {
    country: 'IR',
    callingCode: '+98',
  },
  {
    country: 'MM',
    callingCode: '+95',
  },
  {
    country: 'LK',
    callingCode: '+94',
  },
  {
    country: 'AF',
    callingCode: '+93',
  },
  {
    country: 'PK',
    callingCode: '+92',
  },
  {
    country: 'IN',
    callingCode: '+91',
  },
  {
    country: 'TR',
    callingCode: '+90',
  },
  {
    country: 'CN',
    callingCode: '+86',
  },
  {
    country: 'VN',
    callingCode: '+84',
  },
  {
    country: 'KR',
    callingCode: '+82',
  },
  {
    country: 'JP',
    callingCode: '+81',
  },
  {
    country: 'TH',
    callingCode: '+66',
  },
  {
    country: 'SG',
    callingCode: '+65',
  },
  {
    country: 'NZ',
    callingCode: '+64',
  },
  {
    country: 'PH',
    callingCode: '+63',
  },
  {
    country: 'ID',
    callingCode: '+62',
  },
  {
    country: 'AU',
    callingCode: '+61',
  },
  {
    country: 'CC',
    callingCode: '+61',
  },
  {
    country: 'CX',
    callingCode: '+61',
  },
  {
    country: 'MY',
    callingCode: '+60',
  },
  {
    country: 'VE',
    callingCode: '+58',
  },
  {
    country: 'CO',
    callingCode: '+57',
  },
  {
    country: 'CL',
    callingCode: '+56',
  },
  {
    country: 'BR',
    callingCode: '+55',
  },
  {
    country: 'AR',
    callingCode: '+54',
  },
  {
    country: 'CU',
    callingCode: '+53',
  },
  {
    country: 'MX',
    callingCode: '+52',
  },
  {
    country: 'PE',
    callingCode: '+51',
  },
  {
    country: 'DE',
    callingCode: '+49',
  },
  {
    country: 'PL',
    callingCode: '+48',
  },
  {
    country: 'NO',
    callingCode: '+47',
  },
  {
    country: 'SJ',
    callingCode: '+47',
  },
  {
    country: 'SE',
    callingCode: '+46',
  },
  {
    country: 'DK',
    callingCode: '+45',
  },
  {
    country: 'GB',
    callingCode: '+44',
  },
  {
    country: 'GG',
    callingCode: '+44',
  },
  {
    country: 'IM',
    callingCode: '+44',
  },
  {
    country: 'JE',
    callingCode: '+44',
  },
  {
    country: 'AT',
    callingCode: '+43',
  },
  {
    country: 'CH',
    callingCode: '+41',
  },
  {
    country: 'RO',
    callingCode: '+40',
  },
  {
    country: 'IT',
    callingCode: '+39',
  },
  {
    country: 'VA',
    callingCode: '+39',
  },
  {
    country: 'HU',
    callingCode: '+36',
  },
  {
    country: 'ES',
    callingCode: '+34',
  },
  {
    country: 'FR',
    callingCode: '+33',
  },
  {
    country: 'BE',
    callingCode: '+32',
  },
  {
    country: 'NL',
    callingCode: '+31',
  },
  {
    country: 'GR',
    callingCode: '+30',
  },
  {
    country: 'ZA',
    callingCode: '+27',
  },
  {
    country: 'EG',
    callingCode: '+20',
  },
  {
    country: 'KZ',
    callingCode: '+7',
  },
  {
    country: 'RU',
    callingCode: '+7',
  },
  {
    country: 'US',
    callingCode: '+1',
  },
  {
    country: 'CA',
    callingCode: '+1',
  },
  {
    country: 'AG',
    callingCode: '+1',
  },
  {
    country: 'AI',
    callingCode: '+1',
  },
  {
    country: 'AS',
    callingCode: '+1',
  },
  {
    country: 'BB',
    callingCode: '+1',
  },
  {
    country: 'BM',
    callingCode: '+1',
  },
  {
    country: 'BS',
    callingCode: '+1',
  },
  {
    country: 'DM',
    callingCode: '+1',
  },
  {
    country: 'DO',
    callingCode: '+1',
  },
  {
    country: 'GD',
    callingCode: '+1',
  },
  {
    country: 'GU',
    callingCode: '+1',
  },
  {
    country: 'JM',
    callingCode: '+1',
  },
  {
    country: 'KN',
    callingCode: '+1',
  },
  {
    country: 'KY',
    callingCode: '+1',
  },
  {
    country: 'LC',
    callingCode: '+1',
  },
  {
    country: 'MP',
    callingCode: '+1',
  },
  {
    country: 'MS',
    callingCode: '+1',
  },
  {
    country: 'PR',
    callingCode: '+1',
  },
  {
    country: 'SX',
    callingCode: '+1',
  },
  {
    country: 'TC',
    callingCode: '+1',
  },
  {
    country: 'TT',
    callingCode: '+1',
  },
  {
    country: 'VC',
    callingCode: '+1',
  },
  {
    country: 'VG',
    callingCode: '+1',
  },
  {
    country: 'VI',
    callingCode: '+1',
  },
];
